<template>
  <div class="technical-notes-section">
    <b-container>
      <b-row>
        <b-col>
          <technical-notes-component
            v-if="technicalNotes.length > 0"
            :content="technicalNotes"
          />
          <h4
            v-else
            class="text-center"
          >
            There are no technical notes available for this product.
          </h4>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import TechnicalNotesComponent from './TechnicalNotes.vue'

export default {
  name: 'technical-notes-section',
  components: {
    'technical-notes-component': TechnicalNotesComponent
  },
  props: {
    technicalNotes: {
      type: Array,
      required: true
    }
  }
}
</script>
